"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("../../styles"));
exports.default = (function (_a) {
    var onApply = _a.onApply, onReset = _a.onReset;
    var classes = (0, styles_1.default)();
    return (react_1.default.createElement(core_1.Grid, { container: true, item: true, justify: "flex-end", alignItems: "center", className: classes.footer },
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.buttonGrid },
            react_1.default.createElement(core_1.Button, { color: "primary", className: classes.resetButton, onClick: onReset }, "Reset")),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.buttonGrid },
            react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", className: classes.applyButton, onClick: onApply }, "Apply"))));
});
